'use client'

import { clsx } from 'clsx'
import Image from 'next/image'

interface IProps {
	className?: string
}

export default function ZLoadingOverlay({ className }: IProps) {
	const containerClassName = clsx(
		'bg-medante-background fixed inset-0 flex items-center justify-center z-250',
		className
	)

	return (
		<div
			className={containerClassName}
			role='status'
			aria-live='polite'
			aria-label='Načítavam...'
		>
			<div className='opacity-50'>
				<Image
					unoptimized={true}
					src='/assets/images/medante-logo-dark.svg'
					alt='Medante'
					width={431}
					height={115}
					className='animate-pulse duration-1500 h-14 w-auto'
				/>
			</div>
		</div>
	)
}
